module.exports = __webpack_public_path__ + "img/chrome1.d02b0c7e.png";